import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PlanningOverview from './planning/PlanningOverview';
import PlanningCalendar from './planning/PlanningCalendar';
import Technicians from './planning/Technicians';

const TABS = [
  { label: 'Planning General', icon: <TimelineIcon /> },
  { label: 'Calendario', icon: <CalendarMonthIcon /> },
  { label: 'Tecnicos', icon: <EngineeringIcon /> },
];

export default function Planning() {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>Planning</Typography>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tab} onChange={(e, v) => setTab(v)}
          variant="scrollable" scrollButtons="auto"
        >
          {TABS.map((t) => (
            <Tab key={t.label} label={t.label} icon={t.icon} iconPosition="start" sx={{ minHeight: 56 }} />
          ))}
        </Tabs>
      </Paper>

      {tab === 0 && <PlanningOverview />}
      {tab === 1 && <PlanningCalendar />}
      {tab === 2 && <Technicians />}
    </Box>
  );
}
